import heroHeaderBg from '@/assets/hero-header-bg.png'
import { cn } from '@/utils/cn'
import { useUiStore } from '@/stores/ui.store'
import type { ProductI } from '@/types'

const ProductTile = ({ product }: { product: ProductI }) => {
  const developerMode = useUiStore((store) => store.developerMode)

  return (
    <a
      key={product.id}
      href={product.comingSoon ? undefined : product.url}
      target='_blank'
      rel='noreferrer'
      className='block'
      aria-disabled={product.comingSoon}
    >
      <div
        className='group relative flex min-h-48 items-center justify-center overflow-hidden rounded-sm bg-cover bg-no-repeat text-center text-white lg:aspect-square'
        style={{ backgroundImage: `url(${heroHeaderBg})` }}
      >
        {!!product.badge && (
          <span className='absolute top-2 right-2 z-20 rounded-full bg-gradient-to-r from-sky-700 to-indigo-500 px-3.5 py-1.5 text-sm font-semibold text-white'>
            {product.badge}
          </span>
        )}

        {developerMode && (
          <div className='absolute top-0 left-0 z-10 w-full bg-zinc-400 p-2 text-left text-xs text-zinc-900'>
            {product.url || 'No Link Available'}
          </div>
        )}

        <div className='absolute inset-0 bg-black opacity-90' />

        <div
          className={cn(
            'absolute inset-0 opacity-40 transition duration-300',
            !product.comingSoon && 'group-hover:opacity-60',
          )}
          style={{
            backgroundColor: product.comingSoon
              ? '#8C8C8C'
              : product.backgroundColor,
          }}
        />

        <div
          className={cn(
            'relative z-10 space-y-2 px-4',
            product.comingSoon && 'select-none',
          )}
        >
          <h2 className='sky-text text-base font-semibold tracking-wide uppercase xl:text-xl'>
            {product.name}
          </h2>
          {product.description && (
            <p className='sky-text text-sm font-light xl:text-base'>
              {product.comingSoon ? 'Coming Soon' : product.description}
            </p>
          )}
        </div>
      </div>
    </a>
  )
}

export default ProductTile
